import React from 'react';

const SwivuHomeLogo = () => {
  return (
    <div className="flex justify-center bg-[#ffffff] dark:bg-[#121827] rounded-[50%] px-[0.7em] py-[0.8em] absolute top-[-28px]">
      <button className="border-0 bg-transparent outline-0 cursor-pointer">
        <i className="fa-kit fa-swivu text-5xl text-[#0096ff]"></i>
      </button>
    </div>
  );
};

export default SwivuHomeLogo;
